import { mlsProviderIds } from 'constants/mlsProviderIds';
import type Listing from 'data/listing';
import { isTenantExpCA } from '@tenants';
import type { TenantId } from '@tenants/types';
import { AgentInfo } from 'data/listing/client-app/types/listing';
import { Agent } from 'types/agent';

/**
 * Determines if agent cards should be shown for a given listing.
 * Agent cards are shown when ALL of the following conditions are met:
 * - Tenant is eXp Realty CA
 * - Listing is from Centris provider
 * - Listing is in Quebec province
 */
export function shouldShowAgentCards(listing: Listing, tenantId: TenantId): boolean {
  const isExpCA = isTenantExpCA(tenantId);
  const isCentrisProvider = listing.providerId === mlsProviderIds.centris;
  const isQuebecProvince = listing.province === 'QC';
  return isExpCA && isCentrisProvider && isQuebecProvince;
}

/**
 * Maps AgentInfo from Listing to Agent type for display
 * @param agentInfo - Agent information from listing (with resolved designation)
 * @returns Agent object for display
 */
export function mapAgentInfoToAgent(agentInfo: Omit<AgentInfo, 'designation'> & { designation: string }): Agent {
  return {
    name: agentInfo.name,
    title: agentInfo.designation,
    brokerageName: null,
    brokerageLogo: null,
    email: agentInfo.email,
    phone: agentInfo.phone,
    profileImage: agentInfo.photo,
    providerId: mlsProviderIds.centris, // Default provider
    province: 'QC', // Default province
  };
}

